import React from 'react';
import {
  TableRow,
  TableCell,
  ListItem,
  ListItemText
} from '@material-ui/core';
import { GridSubmitAction } from '@ctsu/ctsu-mui-grid';
import { MUISelect, MUITextBox } from 'components/FormHelpers/FormInputs';
import { compose } from 'recompose';
import { withAppContext } from '@ctsu/loader';
import _ from 'lodash';
import { getEmptyValue } from 'helpers';
import { withChangeHandlers } from 'helpers/Change';

const CredentialDescription = ({ credentialDescription, handleChange }) => (
  <MUITextBox
    title="Credential Description"
    multiline
    rowsMax="2"
    value={getEmptyValue(credentialDescription)}
    onChange={handleChange}
    validators={['required', 'maxStringLength:100']}
    errorMessages={['Required Field', 'Maximum limit of 100']}
    name="credentialDescription"
  />
);

const CredentialType = ({ code, handleChange, psrs }) => {
  const ITRFCodes = _.reduce(psrs, (acc, item) => {
    if (item.code && _.includes(['IMG_PROVIDER_CRED', 'RT_PROVIDER_CRED', 'LINKED_ORG_PROVIDER'], item.verifiedBy)) {
      acc.push(item.code);
    }
    return acc;
  }, []);
  return (
    <MUISelect
      value={getEmptyValue(code)}
      name="code"
      onChange={handleChange}
      validators={['required']}
      errorMessages={['Required Field']}
      title="Credential Type"
    >
      {_.map(_.uniq(ITRFCodes), (item, i) => (
        <ListItem
          button
          key={_.uniqueId('openITR_sel')}
          value={item}
        >
          <ListItemText primary={item} />
        </ListItem>
      ))}
    </MUISelect>
  );
};

const Required = ({ isRequiredYn, handleChange }) => (
  <MUISelect
    name="isRequiredYn"
    validators={['required']}
    errorMessages={['Required Field']}
    value={isRequiredYn === undefined ? true : isRequiredYn}
    onChange={handleChange}
    title="Required?"
  >
    <ListItem button value>
      <ListItemText primary="Yes" />
    </ListItem>
    <ListItem button value={false}>
      <ListItemText primary="No" />
    </ListItem>
  </MUISelect>
);

const Status = ({ esysStatus, handleChange }) => (
  <MUISelect
    value={esysStatus || 'ACTIVE'}
    name="esysStatus"
    onChange={handleChange}
    title="Status"
  >
    <ListItem button value="ACTIVE">
      <ListItemText primary="ACTIVE" />
    </ListItem>
    <ListItem button value="INACTIVE">
      <ListItemText primary="INACTIVE" />
    </ListItem>
  </MUISelect>
);

const CredSwitchBtn = ({ credRequired, handleChange }) => {

  const onClick = () => {
    const customEvent = {
      target: {
        name: 'credRequired',
        value: !credRequired
      }
    };
    handleChange(customEvent);
  };

  return (
    <div
      onClick={onClick}
      onKeyDown={e => {
        if (e.keyCode === 13) onClick();
      }}
      tabIndex={0}
      role="button"
      className="form-layout-wrapper bg-transparent d-inline-flex mr-1"
      style={{ cursor: 'pointer' }}
    >
      <div className="form-input-wrapper d-flex">
        <div className="type-toggle-wrapper">
          <div className="type-toggle">
            <input
              tabIndex="-1"
              id="checkbox_switch_active_inactive"
              type="checkbox"
              checked={credRequired}
              name="From Credentials"
            />
            <span className="type-toggle-slider" />
          </div>
        </div>
      </div>
    </div>
  )
}

const EditOPENIRTFProvider = (props) => {
  const {
    cancel,
    reset,
    state,
    psrs,
    handleChange
  } = props;

  const {
    credentialDescription,
    code,
    isRequiredYn,
    esysStatus,
    credRequired
  } = state;

  return (
    <TableRow>
      <TableCell>
        <CredentialDescription
          credentialDescription={credentialDescription}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        <CredentialType
          code={code}
          psrs={psrs}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        <Required isRequiredYn={isRequiredYn} handleChange={handleChange} />
      </TableCell>
      <TableCell>
        <Status esysStatus={esysStatus} handleChange={handleChange} />
      </TableCell>
      <TableCell>
        <CredSwitchBtn credRequired={credRequired} handleChange={handleChange} />
      </TableCell>
      <TableCell align='center'>
        <GridSubmitAction cancel={cancel} reset={reset} />
      </TableCell>
    </TableRow>
  );
};


const EditOPENIRTFProviderSetup = compose(
  withAppContext,
  withChangeHandlers
)(EditOPENIRTFProvider);

export default EditOPENIRTFProviderSetup;
